/* eslint-disable */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { getValueFromUrl } from '../../helpers/utils';
import {
  fetchAssignmentDetails,
  setAssignmentId,
  enableSpinner,
  createAssignment,
  fetchAssignmentDetailsSuccess,
  getPreviewSingleQuestion
} from './mle-actions';
import { getQuestionSuccess, updateQuestion } from '../activity/activity-actions';
import { LEARNOSITY_SPINNER, MAX_RESPONSES, NO_RESPONSE } from '../../helpers/constants';

// eslint-disable-next-line import/prefer-default-export
export const useAssignUpf = () => {
  const dispatch = useDispatch();
  const { assignmentIdReducer } = useSelector(state => state);
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    const assignmentId = getValueFromUrl('assignmentId');
    const courseId = getValueFromUrl('courseId');
    const learningJourneyId = getValueFromUrl('learningJourneyId');
    const courseVersion = getValueFromUrl('courseVersion');
    const classroomId = getValueFromUrl('classroomId');
    const singleQuestionId = getValueFromUrl('singleQuestionId');
    const locale = getValueFromUrl('locale');
    const onAssignmentCreation = (newAssignmentId) => {
      setSearchParams((searchParams) => {
        searchParams.set('assignmentId', newAssignmentId);

        return searchParams;
      }, { replace: true });
    };
    if (assignmentId) {
      dispatch(setAssignmentId(assignmentId));
    } else if (singleQuestionId) {
      dispatch(fetchAssignmentDetailsSuccess({
        courseId: 0,
        courseVersionId: 0,
        standardId: 0,
        learningJourneyId: 0,
        stepCount: 5,
        stepsCompleted: 0,
        user: {}
      }));
      dispatch(getPreviewSingleQuestion(singleQuestionId, locale));
    } else {
      dispatch(createAssignment({
        courseId,
        learningJourneyId,
        courseVersion,
        classroomId
      }, onAssignmentCreation));
    }
  }, []);

  useEffect(() => {
    const locale = getValueFromUrl('locale');
    if (assignmentIdReducer) {
      dispatch(fetchAssignmentDetails(assignmentIdReducer, locale));
      dispatch(updateQuestion({ assignmentId: assignmentIdReducer, locale }));
      dispatch(enableSpinner(LEARNOSITY_SPINNER));
    }
  }, [assignmentIdReducer]);
};
